export default __webpack_public_path__ + "media/login-img-1.7bd85c9f.svg";